module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('h4', [_vm._v("Logging In...")])]) : _vm._e(), _vm._v(" "), _c('Toast'), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '500px !important'
    }),
    attrs: {
      "header": "Two-Factor Verification",
      "visible": _vm.showCodeVerification,
      "modal": true,
      "closable": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showCodeVerification = $event
      },
      "hide": _vm.resetForm
    }
  }, [_c('div', {
    staticClass: "p-d-flex p-flex-column p-ai-center p-p-4"
  }, [_c('p', {
    staticClass: "p-text-center p-mb-4"
  }, [_vm._v("We've sent a 6-digit verification code to your registered email.")]), _vm._v(" "), _c('InputText', {
    staticClass: "p-mb-4 p-inputtext-sm",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter code"
    },
    model: {
      value: (_vm.verificationCode),
      callback: function($$v) {
        _vm.verificationCode = $$v
      },
      expression: "verificationCode"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-raised p-button-sm",
    attrs: {
      "label": "Verify Code"
    },
    on: {
      "click": _vm.verifyCode
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "p-mt-3 p-text-secondary"
  }, [_vm._v("\n        Didn't receive code? \n        "), _c('a', {
    staticClass: "p-text-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.resendCode.apply(null, arguments)
      }
    }
  }, [_vm._v("Resend")])])], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '500px !important'
    }),
    attrs: {
      "header": "Password Reset",
      "visible": _vm.showResetDialog,
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showResetDialog = $event
      },
      "hide": _vm.resetForm
    }
  }, [_c('div', {
    staticClass: "p-d-flex p-flex-column p-ai-center"
  }, [(_vm.resetStep === 1) ? _c('div', {
    staticClass: "p-fluid",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('InputText', {
    staticClass: "p-mb-4",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.resetEmail),
      callback: function($$v) {
        _vm.resetEmail = $$v
      },
      expression: "resetEmail"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Send Code"
    },
    on: {
      "click": _vm.handleResetEmailSubmit
    }
  })], 1) : _c('div', {
    staticClass: "p-fluid",
    staticStyle: {
      "width": "80%"
    }
  }, [_c('InputText', {
    staticClass: "p-mb-3",
    attrs: {
      "placeholder": "Reset Code"
    },
    model: {
      value: (_vm.resetToken),
      callback: function($$v) {
        _vm.resetToken = $$v
      },
      expression: "resetToken"
    }
  }), _vm._v(" "), _c('Password', {
    staticClass: "p-mb-3",
    attrs: {
      "placeholder": "New Password",
      "toggleMask": ""
    },
    model: {
      value: (_vm.resetPassword),
      callback: function($$v) {
        _vm.resetPassword = $$v
      },
      expression: "resetPassword"
    }
  }), _vm._v(" "), _c('Password', {
    staticClass: "p-mb-4",
    attrs: {
      "placeholder": "Confirm Password",
      "toggleMask": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-raised p-mb-2",
    attrs: {
      "label": "Reset Password"
    },
    on: {
      "click": _vm.handleResetPasswordSubmit
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-text",
    attrs: {
      "label": "Back"
    },
    on: {
      "click": function($event) {
        _vm.resetStep = 1
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fadeIn w-100"
  }, [_c('div', {
    staticClass: "login-form",
    attrs: {
      "id": "formContent"
    }
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('h2', {
    staticClass: "active"
  }, [_vm._v("Sign In")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/inquiry"
    }
  }, [_c('h2', {
    staticClass: "inactive"
  }, [_vm._v("Inquiry")])])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "formInit"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "fadeIn second",
    attrs: {
      "type": "text",
      "id": "uname",
      "placeholder": "Enter your username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "fadeIn third",
    attrs: {
      "type": "password",
      "id": "password",
      "toggleMask": "",
      "placeholder": "Enter your password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Log In"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.checkCreds.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-footer-links"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleForgotPassword.apply(null, arguments)
      }
    }
  }, [_vm._v("Forgot Password?")])])], 1), _vm._v(" "), _vm._m(1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fadeIn first"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": "static/img/eCalculo-Logo.png",
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "formFooter"
    }
  }, [_c('span', {
    staticClass: "underlineHover"
  }, [_vm._v("Powered by")]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "https://raisetech.com.np",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/img/raiseTechlogo.png",
      "alt": "Raiselogo"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14a6da2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 2053
// module chunks = 0